import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import { CookieConsent } from "./components/CookieConsent";
import { AnalyticsDebugPanel } from "./components/AnalyticsDebugPanel";
import { useEffect } from "react";
import { initWebVitals } from "./lib/webVitals";

// Lazy-load non-home routes to keep the initial JS bundle small.
const NotFound = lazy(() => import("./pages/NotFound"));
const CategoryRoute = lazy(() => import("./pages/CategoryRoute"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminSubmissions = lazy(() => import("./pages/admin/AdminSubmissions"));

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => { initWebVitals(); }, []);
  return (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/electrical" element={<CategoryRoute slug="electrical" />} />
            <Route path="/sanitary" element={<CategoryRoute slug="sanitary" />} />
            <Route path="/iron-and-steel" element={<CategoryRoute slug="iron-and-steel" />} />
            <Route path="/tiles" element={<CategoryRoute slug="tiles" />} />
            <Route path="/hardware" element={<CategoryRoute slug="hardware" />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/submissions" element={<AdminSubmissions />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <CookieConsent />
        <AnalyticsDebugPanel />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;
